import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  .managers {
    gap: 4px;
    padding: 0 0.3rem;
    background-color: #ffffff;
    border-radius: 5px;
  }

  .managers-length {
    margin-top: 0.13rem;
    color: #007bff;
  }
`;
